module.exports = __webpack_public_path__ + "static/img/ewm.8b25925.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fair/ewm.jpg
// module id = BJUv
// module chunks = 90